/**
 * In-app push fallback.
 * Используется когда OS-нотификации недоступны (permission denied/default или Notification API нет).
 * Простой emitter — InAppPushHost подписывается и рендерит push-карточки.
 */

import type { NotificationSeverity } from '../types/notification.types';

export interface InAppPushData {
  id: number;
  title: string;
  body?: string | null;
  severity: NotificationSeverity;
  onClick?: () => void;
}

type Subscriber = (data: InAppPushData) => void;

let counter = 0;
const subscribers = new Set<Subscriber>();

export function pushInApp(data: Omit<InAppPushData, 'id'>): void {
  const full: InAppPushData = { ...data, id: ++counter };
  subscribers.forEach((cb) => {
    try { cb(full); } catch (err) { console.error('[inAppPush] subscriber error', err); }
  });
}

export function subscribeInAppPush(cb: Subscriber): () => void {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}
